import { render, staticRenderFns } from "./LoyaltySubscriptionTypeUpdateComponent.vue?vue&type=template&id=28511414&scoped=true"
import script from "./LoyaltySubscriptionTypeUpdateComponent.vue?vue&type=script&lang=ts"
export * from "./LoyaltySubscriptionTypeUpdateComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28511414",
  null
  
)

export default component.exports